//英文
export default {
	pay: {
		waitPay          : "Waiting for Payment",
		purchase         : "Purchase",
		totalAmount      : "Total Amount",
		otherMethods     : "Other Payment Methods",
		payAmount        : "Payment Amount",
		payMethod        : "Payment Method",
		payTime          : "Payment Time",
		complete         : "Complete",
		successfulPayment: "Successful Payment"
	},
	language: {
		switchLanguage: "switch Language",
		return        : "Return"
	},
	order: {
		payOrder          : "Pay order",
		payAmount         : "Payment amount",
		payType           : "payment method",
		payStatus         : "Payment status",
		selectPayment     : "Select Payment Method",
		copy              : "Copy",
		expires           : "Expired",
		orderId           : "Order ID",
		orderDetail       : "Order Details",
		refresh           : "Refresh",
		havePaid          : "I have paid",
		retry             : "Retry",
		use               : "Use",
		problems          : "Are you having problems with payment?",
		otherOne1         : "How to pay through ATM",
		otherOne2         : "1.Visit the nearest ATM before it expires.",
		otherOne3         : "2.Make a transfer using the ATM's transfer function.",
		otherOne4         : "3.Verify the payment code above and enter the transfer.",
		otherOne5         : "4.Make the payment according to the amount.",
		otherTwo1         : "How to pay via online",
		otherTwo2         : "1.Access the corresponding online bank before it expires.",
		otherTwo3         : "2.Make a transfer using the online bank's transfer function.",
		otherTwo4         : "3.Verify the payment code above and enter it.",
		otherTwo5         : "4.Pay according to the amount.",
		otherThree1       : "How to pay through mobile banking",
		otherThree2       : "1.Visit the nearest bank before it expires.",
		otherThree3       : "2.Notify the cashier to make the payment.",
		otherThree4       : "3.Tell or show the payment code above.",
		otherThree5       : "4.Pay according to the amount.",
		rechargeSuccessful: "Recharge successful",
		gold              : "Gold",
		rewardCoins       : "Reward coins",
		ovo               : "OVO Payment",
		amountDue         : "Amount Due",
		changePayment     : "Change Payment",
		proceedtoPay      : "Proceed to Pay",
		phoneNumber       : "Phone Number",
		phoneNumber       : "Phone number",
		phoneNumber2      : "Please enter a valid phone number",
		phoneNumber3      : "Please enter your phone number",
		orderForm1        : "Order has been created",
		orderForm2        : "Please proceed to",
		orderForm3        : "Complete the payment"

	},
	recharge: {
		recharge             : "Top-up",
		coins                : "Coins",
		bonus                : "Bonus",
		GoldCoinRechargeRules: "Gold Coin Recharge Rules:",
		goldCoinsAreVirtual  :
      "Gold coins are virtual items and cannot be refunded. They are only used to unlock premium content within the app.",
		expiredDeletion:
      "Recharge equivalence: 1 gold coin = 1 bonus. Please note that recharge refunds are not supported.",
		expiredWillBeInvalidated:
      "Please ensure to utilize the bonus coins obtained through recharge or participation in activities within their validity period, as they will become invalid upon expiration.",
		goldCoinsNotReceived:
      "If the coins are not credited in time after recharging,",
		rechargeAgreement: "Top-up implies agreement to the",
		protocol         : "《Top-up Agreement》",
		specialOffer     : "Special Offer",
		extra            : "Extra",
		unlockAll        : "Automatically unlock episodes",
		day              : "day",
		subscribe        : "Subscribe",
		price            : "Price",
		goldMall         : "Gold Coin Mall",
		balance          : "Balance",
		unlock           : "Unlock",
		episode          : "Episode",
		timeLimited      : "Limited time first deposit",
		time             : "Limited time",
		otherOptions     : "Other options",
		luckyUser        : "Congratulations on being selected as a lucky user with the best discount package",
		HH               : "HH",
		MM               : "mm",
		SS               : "ss",
		payNow           : "Pay Now",
		unlockWeek       : "Unlock all series within a week",
		unlockMonth      : "Unlock all series within a month",
		unlockYear       : "Unlock all series within a year",
		renew            : "Renew",
		next             : "Next step",
		newUser          : "New user reward",
		only             : "Only",
		left             : "left",
		monthly          : "Month",
		annual           : "Year",
		weekly           : "Week",
		firstWeek        : "First week"
	},
	home: {
		loading        : "Loading data...",
		all            : "All",
		ep             : "EP",
		classification : "Classification",
		recentlywatched: "Recently Watched",
		collection     : "Bookmark",
		language       : "Language",
		logOut         : "Log out",
		refresh        : "Refresh",
		login          : "Login"
	},
	otherpage: {
		otherpage1:
      "After recharging gold coins, the gold coins are delayed in arriving",
		otherpage2:
      "Due to network issues, the arrival of the gold coins may be delayed. In such cases, you need to wait for the network to improve and then go to the recharge page. If it still doesn't work, you will receive a refund from Google or Apple after 3 days.",
		otherpage3:
      "If the gold coins are not credited in time, it may be due to network congestion causing delays. Don't worry, the system will re-verify, and generally, the coins will be automatically credited by 18:00 on the second business day. If for other reasons the coins are still not credited, the amount will be refunded to the original payment account within three business days.",
		otherpage4    : "Feedback",
		inviteFriends1: "Invite to watch",
		inviteFriends2:
      "Watch one episode after entering ReelBuzz, friends can get BOINS rewards",
		inviteFriends3: "Reminder：",
		inviteFriends4: "Download",
		inviteFriends5: "Popular TV series",
		inviteFriends6: "Invite friends",
		inviteFriends7: "Cannot Subscribe Again",
		jelaskan1     :
      "Subscription Instructions:\n• Membership Purchase: The purchase period is 30 days, 365 days, or 7 days. The purchase price depends on the product.\n• Subscription Renewal: The Google Pay account will be charged 24 hours before the expiration date. Once the payment is successful, the subscription will be extended for one period.The subscription service will continue until you cancel.\n• Cancel Subscription: Go to Google Pay - Subscriptions - Select Reelbuzz to cancel the subscription.\n• No Refund: Once the membership service is activated, no refunds will be given, and it does not apply to the no-questions-asked return policy.\n• If you have any questions about the membership service, click My - Feedback, enter the feedback page, and contact us. Our customer service staff will handle your problem.",
		questionnaire: "Questionnaire"
	},
	whatsapp: {
		paling           : "Most popular",
		countDown        : "Count Down",
		extra            : "Extra",
		rules            : "Event Rules",
		eventDuration    : "Event Duration: This recharge discount is valid for 24 hours.",
		eventDuration2   : "How to Participate: Users can recharge through the event page to receive additional rewards.",
		eventDuration3   : "Participation Restriction: Each user has only one chance to participate and can only choose one of two recharge options.",
		rechargeAgreement: "By recharging, you agree to the Recharge Agreement",
		exclusive        : "Exclusive Event",
		event            : "Event"
	},
	userCancellationAgreement: {
		details : "Account deletion is an",
		details2: "irreversible action.",
		details3: "Before proceeding, please ensure that you have backed up all information related to your account and that all associated services have been properly handled.Any future registration will only create a new account.Once your account is deleted, you will not be able to use that account again, nor will you be able to recover any information, content, data, or services associated with it on the Reelbuzz platform—even if you re-register using the same phone number, email address, or other credentials.This includes but is not limited to: ",
		details4: "All assets under your account will be cleared. By deleting your account, you voluntarily forfeit all assets and rights associated with it, including coins, rewards, membership benefits, and other assets. We recommend that you use up all assets and properly handle any asset-related issues before deleting your account.",
		details5: "If you use Google Pay or Apple Pay, please be sure to check your subscription status and cancel auto-renewal. If not canceled, Google or Apple may continue to charge you subscription fees according to your agreement with them. For any disputes or refund requests regarding subscription fees, please contact Google or Apple directly.",
		details6: "2.All account data will be deleted or anonymized. Your profile and usage information will be deleted or anonymized and cannot be recovered, including but not limited to username, email address, viewing history, favorites, purchase history, top-up records, third-party login accounts, and any content or information you have added (including both free and paid content).",
		details7: "3.If there is any specific content or information you currently need or may need in the future, please make sure to save a copy before deleting your account.Deleting your account does not affect any agreements already executed between you and Reelbuzz.If you have entered into any agreement with Reelbuzz, it will remain in effect and both parties should continue to fulfill their obligations according to the terms.For example, authorized works will not be removed or taken down before the agreement expires.For more information, please contact us at:",
		details8: "If your account has been reported by other users, is under investigation by law enforcement, involved in litigation or arbitration, or if Reelbuzz believes (at its sole and absolute discretion) that the account is at risk of being stolen or blocked (“termination issue”), Reelbuzz reserves the right to terminate the deletion process without notifying you.After you request to delete your account, you will have 30 days to change your mind and cancel the deletion.If everything proceeds smoothly and there is no “termination issue” during this period, your information may take up to 120 days to be completely deleted or anonymized.When you delete your account, we will make our best effort to delete all personal data associated with your account.However, for financial reporting purposes, we must retain records of past transactions and may need to keep certain information to comply with court orders or other legal processes.We will also retain a record of the deleted account to fulfill legal obligations and when it is necessary for the legitimate interest of account security.Please note that account deletion does not exempt you from any responsibility for actions performed on the account prior to deletion.",
		details9: "services@reelbuzztv.com。"
	},
	prizeDraw: {
		ruleTip         : "Aturan Acara",
		rules1          : "1. Selama periode acara, halaman utama akan menampilkan pop-up dan widget pintu masuk acara, memungkinkan pengguna untuk memasuki halaman acara. ",
		rules2          : "2. Pengguna yang berhasil berlangganan melalui promosi ini akan secara otomatis mengaktifkan fitur perpanjangan langganan.  ",
		rules3          : "3. Selama periode langganan, pengguna dapat menonton semua drama tanpa batas.  ",
		rules4          : "4. Setelah berhasil berlangganan, pengguna akan otomatis terdaftar dalam undian hadiah ponsel. Setelah acara berakhir, pengguna dapat memeriksa hasil undian.  ",
		rules5          : "5. Setelah pembelian, pengguna dapat membatalkan langganan kapan saja. Dalam 24 jam sebelum periode langganan saat ini berakhir, akun Anda akan secara otomatis diperpanjang dan biaya akan dipotong.  ",
		rules6          : "6. Jika Anda memiliki pertanyaan, silakan hubungi layanan pelanggan: **Profil → Layanan Pelanggan**. ",
		rules7          : "7. **Reelbuzz memiliki hak interpretasi akhir atas promosi ini.**",
		stepsTip        : "Ikuti undian ponsel",
		step1           : "Langkah pertama: Menjadi anggota dan otomatis mendaftar ke acara~",
		step2           : "Langkah kedua: Tunggu pengumuman hasil undian setelah acara berakhir.",
		step3           : "Langkah ketiga: Periksa pengumuman hasil undian.",
		step4           : "Langkah keempat: Jika Anda memenangkan hadiah, harap tinggalkan kontak Anda, dan staf kami akan menghubungi Anda.",
		nubiaPhonetip   : "menjelang Hari Raya Idul Fitri, sebagai bentuk terima kasih atas dukungan Anda terhadap Reelbuzz, kami akan membagikan sejumlah hadiah. Klik tombol pendaftaran untuk mengikuti undian, dan Anda berkesempatan memenangkan smartphone terbaru",
		prizeInformation: "Informasi Hadiah",
		signup          : "Daftar",
		sorry           : "Mohon maaf",
		activityOver    : "cara telah berakhir.",
		congratulation  : "Selamat, Anda menang!",
		sorryForNotYou  : "Sayangnya, Anda tidak memenangkan hadiah.",
		uncommitted     : "Anda tidak ikut serta dalam acara ini",
		name            : "Nama ",
		phone           : "Nomor telepon",
		getcode         : "Dapatkan",
		code            : "Kode verifikasi",
		vipUser         : "Anggota",
		firstWeek       : "Minggu pertama",
		everyWeek       : "minggu",
		originWeek      : "Setiap minggu",
		allFree         : "Semua episode bisa ditonton gratis",
		joinPrize       : "Ikuti undian ponsel.",
		priceDown       : "Diskon",
		Register        : "Daftar undian",
		dearVip         : "Pelanggan yang terhormat",
		signupSuccess   : "Pendaftaran berhasil",
		waitResult      : "Harap funggu pengumuman hasil",
		connectWay      : "Tinggalkan kontak Anda",
		hasconnectWay   : "Kontak telah disediakan",
		usernickName    : "Nama pengguna",
		prize           : "Hadiah",
		pleaseName      : "Silakan isi nama",
		pleaseCode      : "Silakan isi kode verifikasi.",
		pleasePhone     : "Silakan isi nomor ponsel",
		subSuccess      : "Pengiriman berhasil.",
		submit          : "Konfirmasi",
		cancleTip       : "erpanjangan otmatis batalkan kapan saja",
		phoneName       : "Ponsel"
	}, 
	inviteActivity: {
		startInvite   : "Mulai mengundang teman",
		invite        : "Undang teman",
		couponNumber  : "kupon undian",
		getIcons      : "Bonus",
		activityTitle : "Aktivitas hadiah",
		titleStep1    : "Undang pengguna untuk mengunduh Reelbuzz",
		titleStep2    : "Pengguna menonton selama 10 menit",
		titleStep3    : "Pengguna melakukan isi ulang",
		activityStep  : "Cara mengundang teman",
		step1         : "Langkah 1: Klik untuk mulai mengundang teman",
		step2         : "Langkah 2: Bagikan tautan ke teman atau posting ke Facebook",
		step3         : "Langkah 3: Teman mengunduh Reelbuzz dan menonton drama pendek",
		step4         : "Langkah 4: Dapatkan koin hadiah dan kupon undian HP",
		step5         : "LLangkah 5: Tunggu hasil undian",
		activityRank  : "Peringkat undangan teman",
		rank          : "Peringkat",
		userName      : "Nama panggilan",
		inviteCount   : "Mendapatkan Hadiah",
		copyLink      : "Salin URL",
		stepText1     : "Langkah Pertama",
		stepText2     : "Langkah Kedua",
		stepcontent1  : "Klik untuk mengunduh",
		stepcontent2  : "Buka aplikasi dan kunjungi halaman aktivitas undang teman",
		nowGet        : "Dapatkan Sekarang",
		getDownnowload: "Unduh sekarang untuk segera mendapatkan",
		direc         : "Menurut saya ini adalah aplikasi drama pendek lokal terbaik di Indonesia. Aplikasi ini memiliki drama pendek lokal Indonesia terbanyak. Kamu bisa mengunduh aplikasi ini untuk merasakan pesona drama pendek. Unduh sekarang!",
		userNick      : "Nama panggilan pengguna yang diundang",
		congradulate  : "Selamat",
		asinviter     : "Sebagai pengguna yang diundang",
		youget        : "Kamu telah mendapatkan",
		getNow        : "Klaim Sekarang",
		mostIcons     : "Dapatkan hingga"
	},
	inviteDraw: {
		hasContactWay: "Kontak Telah Disimpan",
		contactWay   : "Masukkan Kontak",
		nickName     : "Nama Panggilan",
		confirm      : "Konfirmasi",
		name         : "Nama Lengkap",
		rank         : "Peringkat",
		getReward    : "Dapatkan Hadiah",
		youHasGot    : "Anda telah mendapatkan",
		sorry        : "Anda tidak berpartisipasi dalam acara ini",
		phone        : "Nomor Ponsel",
		getCode      : "Dapatkan Kode",
		code         : "Kode SMS",
		rules1       : "1. Selama periode acara, pengguna yang berpartisipasi dapat memperoleh hadiah Bonus dan kupon undian ponsel melalui mengundang teman.",
		rules2       : "2. Setelah acara berakhir, secara acak akan dipilih 5 pengguna yang memegang kupon undian untuk memenangkan ponsel nubia smartPhone; semakin banyak kupon yang dimiliki, semakin besar peluang menang.",
		rules3       : "3. Hadiah Bonus akan langsung dikirim ke saldo akun pengguna secara real time.",
		rules4       : "4. Peringkat disusun dari hadiah terbanyak ke terendah; jika hadiah sama, diurutkan berdasarkan waktu penyelesaian.",
		rules5       : "5. Jika ada pertanyaan, silakan hubungi Layanan Pelanggan: Profil - Layanan Pelanggan.",
		rules6       : "6. **Reelbuzz memiliki hak interpretasi akhir atas promosi ini.**",
		totalGet     : "Anda telah memperoleh dalam acara ini"
	},
	catGame: {
		saleSuccess      : "Sale Success Bnous+",
		thinkAgain       : "Cancel",
		confirmSale      : "Sale",
		saleTip          : "Sale is irreversible, cat will disappear forever",
		saleNumber       : "Quantity to Sell",
		sale             : "Sell",
		noThisCat        : "Not yet obtained this kitten~",
		inventory        : "Inventory ",
		saleCat          : "Sell Cat",
		noMore           : "No more~",
		heHasNocat       : "He doesn’t have a kitten yet~",
		youcanPet        : "You can still pet ",
		youcanPetTime    : "times today~",
		downReelBuzz     : "Download Reelbuzz",
		adoptCat         : "adopt kittens~",
		petCat           : "Pet the kitten",
		adoptMycat       : "Adopt my kitten~",
		catPending       : "Catball Pending~",
		addToGallery     : "Add to Kitten Gallery",
		addToBag         : "Add to Gallery and sell",
		notSell          : "Not buying for now",
		raisingCountdown : "Raising Countdown",
		continueRaising  : "Continue Raising",
		congrats         : "Congrats, you got",
		open             : "Open",
		openCat          : "Open Catball",
		noRecords        : "No records yet",
		tips             : "Tip:",
		tipOne           : "Each kitten can be petted 10 times during hatching~",
		tipTwo           : "Each kitten can be petted 15 times during raising~",
		tipThree         : "Successfully invite a friend to install and register Reelbuzz to earn reward coins",
		pettedYourcat    : "Petted your kitten",
		catLog           : "Cat Petting Log",
		others           : "Others",
		copyUrl          : "Copy URL",
		copySuccess      : "Copy Success",
		shareNow         : "Share",
		startPush        : "Enable notification, receive hatching status",
		notification     : "Activity Notification",
		shareFriendOne   : "Share with friends",
		shareFriendTwo   : "Pet kittens",
		acceptPush       : "Accept Notification",
		hatchingCountdown: "Hatching Countdown",
		ruleOne          : "Finish any show to get a Catball~",
		ruleTwo          : "A kitten is currently hatching ",
		ruleThree        : "Claim Catball from viewing history in profile",
		ruleFour         : "Hatching and raising take time, invite friends to pet cats and speed up~",
		ruleFive         : "Adult cats after hatching will be added to the gallery",
		ruleSix          : "Duplicate adult cats can be sold in backpack",
		startHatching    : "Hatching",
		catBall          : "Catball",
		catHouse         : "Kitten",
		catGallery       : "Kitten Gallery",
		myBag            : "My Cat Bag",
		catchRaising     : "Cat Raising Guide",
		goHome           : "Go Home",
		selectCat        : "Select a Catball",
		raisingSuccess   : "Raising Success",
		rasing           : "Raising: ",
		waitOpen         : "To be unlocked",
		hatching         : "Hatching: ",
		hatchingSuccess  : "Hatching Success:",
		freeTime         : "Idle",
		confirm          : "Confirm",
		pleaseEnterName  : "Please enter a nickname",
		nickName         : "Nickname",
		putAway          : "Put it away~",
		startRaising     : "Start Raising Cats",
		yayGot           : "Yay, got a Catball ",
		claimCatball     : "Claim",
		viewingHistory   : "Viewing History",
		square           : "Square",
		home             : "Profile",
		myCat            : "Kitten",
		raisingCat       : "Raise a Kitten",
		nocatYey         : " You haven’t got a kitten yet, go adopt one~",
		grown            : "Growth Boost",
		dramaCommend     : "Short Drama Recommendation",
		watchEpisodes    : "Watch Episodes",
		Raise            : "Raise",
		Hatch            : "Hatch",
		redeemRewards    : " Redeem Rewards",
		welcomeTo           : "Welcome to",
		ofCatHouse          : "'s Cat House",
		goToSquare          : "Go to Plaza",
		hatchComplete       : "Hatching Complete",
		hatchCompleteTip    : "Your kitten has hatched, come take a look~",
		petSpeedTip         : "Petting speeds up growth by 1 hour, up to 10 times",
		petToSpeedHatch     : "The kitten is hatching, pet it to speed it up",
		maxPetTimes         : "Each kitten can receive up to 10 pets",
		someoneHelped       : "Boosted for you",
		helpedOneHour       : "Sped Up by 1 Hour",
		hasLiked            : "Liked",
		like                : "Like",
		setFavorite         : "Set Favorite",
		catRanking          : "Ranking",
		viewProfile         : "Profile",
		rankingUpdateTip    : "Updates Daily at 00:00",
		raiseCats           : "Raise Cats",
		catUnit             : "Cats",
		selectMonth         : "Select Month",
		dramaLovingCat      : "A drama-loving kitty~",
		clickTap            : "Tap",
		giveLike            : "Give them a like",
		favoriteDrama       : "Favorite Drama",
		change              : "Change",
		watch               : "Watch",
		noFavoriteDramaClick: "No favorite dramas yet, tap to choose",
		noFavoriteDrama     : "No favorite dramas yet",
		bio                 : "Bio",
		male                : "Male",
		female              : "Female",
		likeHistory         : "Like History",
		likedYou            : "Liked your post",
		noLikeHistory       : "No like history yet",
		operationFailed     : "Operation Failed"
	},
	valentineDay: {
		notExpired        : "Not yet",
		completed         : "Completed",
		go                : "Go complete",
		exchange          : "Rules",
		exchanged         : "Redeemed",
		exchangeCount     : "Redemption attempts",
		taskType1         : "Daily login",
		taskType2         : "Log in on Valentine’s Day",
		taskType3         : "Watch dramas over",
		taskType4         : "Watch 2 video ads",
		taskType5         : "Tonton 1 drama penuh",
		taskType6         : "Subscribe VIP",
		taskType7         : "Watch",
		taskType8         : "Invite 1 new user",
		taskType9         : "Share with friends",
		taskType10        : "Log in on Valentine’s Day",
		heartValue        : "Heart Points",
		rule              : "Rules",
		shareTitle        : "Share to earn Heart Points",
		headFrame         : "Avatar Frame",
		coin              : "Reward Coins",
		receiveReward     : "Claim",
		valentinaHeadFrame: "Valentine Frame",
		hadSeen           : "Watched",
		pushMe            : "Remind me",
		changeTimes       : "Redemption attempts",
		got               : "Obtained",
		day               : "day",
		detail            : "Details",
		income            : "Earned",
		expenditure       : "Spent",
		noData            : "No Details",
		gotoActivity      : "Go to event",
		pleaseUpgrade     : "Please update the app to the latest version",
		minute            : "minutes",
		over              : "Ended",
		activityOver      : "This event has ended",
		seeName           : "Watch 《Cinta Lama Bertemu Kembali》",
		countTime         : "Time remaining",
		dayilyTask        : "Daily tasks",
		specialTask       : "Special tasks",
		eventRewards      : "Event Rewards",
		notRelease        : "This drama is not yet released",
		rulesContent      : "Event Time:Feb 4, 2026, 00:00 – Feb 19, 2026, 23:59. During the event, complete daily tasks and designated event tasks to earnHeart Points. Heart Points can be redeemed forVIP membership,Valentine’s Day exclusive avatar frames, andBonus rewards. Unused Heart Points will be cleared after the event ends. Event rules and rewards are subject to the information shown on the event page."
	},
	caimH5: {
		onlyleft          : "Hanya kurang ",
		canGet            : "lagi untuk Withdraw",
		hasGot            : "Jumlah yang Sudah Didapat",
		//待获得金额
		pendingGet        : "Jumlah yang Akan Didapat",
		//距离
		distance          : "Jarak ke",
		onlyDiamond       : "Kurang Berlian",
		pendingDiamond    : "Jumlah yang Akan Berlian",
		rules             : "Peraturan",
		rewordsList       : "Catatan Hadiah",
		inviteFriends     : "Undang Teman",
		getRewards        : "Dapatkan ",
		//抽奖
		drawChance        : "x Kesempatan Undian",
		chance            : "Kesempatan",
		//助力记录
		helpRecord        : "Catatan Bantuan",
		close             : "Tutup",
		//再送您
		againSendYou      : "Diberikan lagi",
		justInvite        : "Cukup undang",
		oneFriend         : "1 teman mendaftar",
		register          : "mendaftar",
		//太棒啦，获得
		great             : "Hore! Dapat",
		//谢谢惠顾
		thanksForVisiting : "Terima Kasih",
		shareTitle        : "Bagikan ke teman untuk dapat kesempatan hadiah",
		//点击
		clickToDownload   : "Klik untuk Unduh ReelBuzz",
		downLoadandEnter  : "Unduh ReelBuzz & Masuk",
		clickToParticipate: "Klik untuk Ikut Event",
		enterReelbuzz     : "Masuk ke ReelBuzz untuk ikut event Withdraw",
		getMoney          : "Dapatkan Hadiah Tunai",
		getMoneyNow       : "Selesaikan syarat event dan dapatkan hadiah tunai"
	}
};
